<template>
    <div class="card mt-5">
        <div class="card-body">

            <div class="row pb-4">
                <div class="col-sm-6">
                    <strong style="font-size:20px">Laporan BPJS</strong>
                </div>
                <div class="col-sm-6 d-flex justify-content-end">
                    <b-button variant="primary" size="sm" class="text-capitalize" @click="download">Download</b-button>
                </div>
            </div>
            <b-row>
                <b-col sm="12" lg="6">
                    <b-row class="align-items-center mb-2">
                        <b-col sm="4" lg="2">
                            <p class="text-capitalize m-0">periode</p>
                        </b-col>
                        <b-col sm="4" lg="4">
                            <b-form-select size="sm" v-model="periodeSelected" :options="filterPeriode"></b-form-select>
                        </b-col>
                        <b-col sm="8" offset-sm="4" offset-lg="2" lg="6" class="mt-2" v-if="selectedPeriodeRange">
                            <DatePickerX v-model="dateRange" is-range
                                :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
                                :masks="{ input: 'DD-MM-YYYY' }" :max-date="maxDate" :min-date="minDate">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="flex justify-center items-center">
                                        <template v-if="dateRange">
                                            <input readonly :value="inputValue.start + ' - ' + inputValue.end"
                                                v-on="inputEvents.start"
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                        </template>
                                        <template v-else>
                                            <input readonly placeholder="Pilih Tanggal" v-on="inputEvents.start"
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                        </template>
                                    </div>
                                </template>
                            </DatePickerX>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="12">
                            <small class="font-italic" style="color: red">
                                *Data yang ditampilkan maksimal 3 bulan terakhir
                            </small>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" lg="6">
                    <b-row class="mb-2">
                        <b-col sm="4" lg="7" class="text-right-lg">PERIODE</b-col>
                        <b-col sm="8" lg="5">
                            <b-form-input class="text-right" size="sm" disabled
                                :value="periodeX({ periode: periodeSelected, rawValue: true })" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="4" lg="7" class="text-right-lg">TOTAL PASIEN</b-col>
                        <b-col sm="8" lg="5">
                            <b-form-input class="text-right" size="sm" disabled
                                :value="totalPasienValue == '0' || !totalPasienValue ? '0' : totalPasienValue + ' Orang'" />
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <DataTableWrapper
                :perPage="perPage"
                :currentPage="currentPage"
                :customPagingClass="['custom-pagination']"
                :customEntryOptions="{ f: customEntryOptions }"
                dropdownSizeProps="sm"
                :rows="rows"
                :fromPage="fromPage"
                :toPage="toPage"
                @pageChanged="handleValueChanged"
            >
                <b-table
                    id="report-purchase-table"
                    :items="dataList"
                    :fields="fieldList"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :no-local-sorting="true"
                    :responsive="true"
                    :sticky-header="true"
                >
                    <template v-slot:cell()="data">
                        <template v-if="
                            data.item.leaveBlank
                            && data.field.key
                            && ![
                                'no',
                                'waktu_konsultasi',
                                'usia',
                                'jumlah_obat_bhp',
                            ].includes(data.field.key)
                        ">
                            <vue-select
                                v-if="data.field.key == 'jenis_kelamin'"
                                :options="listJenisKelamin"
                                v-model="selectedJenisKelamin"
                                class="custom-v-select w-95 mt-2"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </vue-select>
                            <vue-select
                                v-else-if="data.field.key == 'jenis_kunjungan'"
                                :options="option_jenis_kunjungan"
                                v-model="selectedKunjungan"
                                class="custom-v-select w-95 mt-2"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </vue-select>
                            <vue-select
                                v-else-if="data.field.key == 'perawatan'"
                                :options="option_perawatan"
                                v-model="selectedPerawatan"
                                class="custom-v-select w-95 mt-2"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.label }}
                                </template>
                            </vue-select>
                            <vue-select
                                v-else-if="data.field.key == 'kegiatan'"
                                :options="option_kegiatan"
                                v-model="selectedKegiatan"
                                class="custom-v-select mt-2"
                            >
                                <!-- <template slot="option" slot-scope="option">
                                    {{ option.nama }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.nama }}
                                </template> -->
                            </vue-select>
                            <b-input v-else size="sm" class="mt-2 w-95" @input="searchValueChanged($event, data.field.key)" />
                        </template>
                        <div class="text-wrap text-break custom-tooltip" v-else>
                            <template v-if="data.value && data.field.substr && data.field.substr != undefined">
                                <p
                                    class="text-truncate d-inline-block w-100 pr-2 m-0"
                                    v-if="data.value.length > (data.field.substr / 7.5)"
                                    :id="`${data.field.key}-bpjs-${data.item.pembayaran_id}`"
                                >
                                    {{ data.value.substring(0, (data.field.substr / 7.5)) + '...' }}
                                    <b-popover :target="`${data.field.key}-bpjs-${data.item.pembayaran_id}`" triggers="hover" placement="leftbottom">
                                        <small>{{ data.value }}</small>
                                    </b-popover>
                                </p>
                                <p class="m-0" v-else>{{ data.value || '-' }}</p>
                            </template>
                            <template v-else-if="data.item.leaveBlank">{{ data.value }}</template>
                            <template v-else>{{ data.value || '-' }}</template>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <div v-if="!data.item.leaveBlank">
                            <b-button
                                v-if="data.item.jenis_kunjungan==='Kunjungan Sakit'"
                                variant="primary" size="sm"
                                class="text-capitalize"
                                @click="detailPembayaran(data.item.pembayaran_id)">
                                lihat struk
                            </b-button>
                            <b-button
                                v-else
                                variant="primary" size="sm"
                                class="text-capitalize"
                                @click="showDetailAntrean(data.item.transklinik_id)">
                                lihat detail
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </DataTableWrapper>
        </div>
        <!-- MODAL DETAIL ANTREAN -->
        <b-modal
            size="lg"
            v-b-modal.modal-tall
            ref="my-modal"
            title="Detail Kunjungan BPJS"
            @hidden="onHiddenModalDetailHandler"
            :no-close-on-backdrop="true"
            content-class="modal_detail_antrean"
            >
            <div class="accordion mt-4" role="tablist" v-if="detailAntrean">
                <div class="data-pasien">
                    <div
                        class="row pointer"
                        @click="visible_section_1 = !visible_section_1"
                    >
                        <div class="col-md font-weight-bold">
                        Data Pasien
                        </div>
                        <div class="col-md text-right">
                        <font-awesome-icon
                            style="font-size: 24px;"
                            :icon="['fas', 'chevron-down']"
                            :class="{
                            'rotate-0': visible_section_1,
                            'rotate-90': !visible_section_1
                            }"
                        />
                        </div>
                    </div>
                    <hr />
                    <b-collapse
                        id="accordion-1"
                        v-model="visible_section_1"
                        role="tabpanel"
                    >
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Nama Pasien" :value="dataPeserta.nama" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="No.BPJS" :value="dataPeserta.noKartu" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Status Peserta" :value="dataPeserta.hubunganKeluarga" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Tanggal lahir" :value="formattedTanggalLahir" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="kelamin" :value="jenisKelamin(detailAntrean.pasien.jenis_kelamin)"/>
                        <InfoRow customClass="font-weight-bold text-capitalize" label="PPK Umum" :value="`${dataPeserta.kdProviderPst.kdProvider} - ${dataPeserta.kdProviderPst.nmProvider}`" />

                        <InfoRow
                            label="No. Handphone"
                            customClass="font-weight-bold text-capitalize"
                            :value="
                                detailAntrean.pasien.nomor_hp_prefix
                                ? '+' +
                                    detailAntrean.pasien.nomor_hp_prefix +
                                    detailAntrean.pasien.nomor_hp
                                : detailAntrean.pasien.nomor_hp
                        "
                        />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Provinsi"
                            :value="detailAntrean.pasien.provinsi_nama"
                        />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Kota/Kab"
                            :value="detailAntrean.pasien.kota_nama"
                        />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Alamat"
                            :value="detailAntrean.pasien.alamat_rumah"
                        />

                        <InfoRow customClass="font-weight-bold text-capitalize" label="Waktu Konsultasi" :value="`${formatDateTime(detailAntrean.anamnesa.created_at)}`" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Jenis Kunjungan" :value="detailAntrean.jenis_kunjungan_label" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Perawatan" :value="detailAntrean.perawatan_label" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Kegiatan" :value="detailAntrean.kegiatan.nama" />
                    </b-collapse>
                </div>
                <div class="informasi-lain mt-4">
                    <div
                        class="row pointer"
                        @click="visible_section_2 = !visible_section_2"
                    >
                        <div class="col-md font-weight-bold">
                            Keluhan, Antroprometri & Tanda Tanda Vital
                        </div>
                        <div class="col-md text-right">
                        <font-awesome-icon
                            style="font-size: 24px;"
                            :icon="['fas', 'chevron-down']"
                            :class="{
                            'rotate-0': visible_section_2,
                            'rotate-90': !visible_section_2
                            }"
                        />
                        </div>
                    </div>
                    <hr />
                    <b-collapse
                        id="accordion-2"
                        v-model="visible_section_2"
                        role="tabpanel"
                    >
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Keluhan" :value="detailAntrean.anamnesa.keluhan" />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Anamnesa" :value="detailAntrean.anamnesa.notes" />

                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Tinggi Badan"
                            :value="detailAntrean.anamnesa.tinggi_badan"
                        />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Berat Badan"
                            :value="detailAntrean.anamnesa.berat_badan"
                        />
                        <InfoRow
                        customClass="font-weight-bold text-capitalize"
                            label="Lingkar Perut"
                            :value="detailAntrean.pasien.lingkar_perut"
                        />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="IMT" :value="detailAntrean.anamnesa.imt" />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Sistole"
                            :value="detailAntrean.anamnesa.tensi_sistole"
                        />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Diastole"
                            :value="detailAntrean.anamnesa.tensi_diastole"
                        />
                        <InfoRow customClass="font-weight-bold text-capitalize" label="Nadi" :value="detailAntrean.anamnesa.nadi" />
                        <InfoRow
                            customClass="font-weight-bold text-capitalize"
                            label="Respirasi"
                            :value="detailAntrean.anamnesa.respirasi"
                        />
                    </b-collapse>
                </div>
            </div>

            <template v-slot:modal-footer>
                <div class="w-100">
                <b-button
                    variant="primary"
                    class="float-right"
                    @click="toggleDetailAntrean"
                >
                    Tutup
                </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
  
<script>
import moment from 'moment';
import debounce from 'lodash/debounce';
import startCase from 'lodash/startCase';
import { mapGetters } from 'vuex';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { ThousandSeparator } from '../../helpers/global'
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faArrowRight,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";


locale.use(lang);

library.add(
  faChevronDown,
  faArrowRight,
);

export default {
    components: {
        DataTableWrapper: () => import('../../components/DataTableWrapper2'),
        'vue-select': () => import('vue-select'),
        DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
        "font-awesome-icon": FontAwesomeIcon,
        InfoRow: () => import("../KlinikAntrean/components/InfoRow.vue")
    },
    data() {
        return {
            sortBy: '',
            sortDesc: false,
            currentPage: 1,
            perPage: 10,
            customEntryOptions: [5],
            periodeSelected: 'hari ini',
            dateRange: null,
            periodeValue: null,
            totalPasienValue: null,
            totalPendapatanValue: null,
            searchValue: [],
            dataList: [],
            fromPage: 0,
            toPage: 0,
            rows: 0,
            totalEntries: 0,
            waktuKonsultasi: '',
            tanggalLahir: '',
            allowSearch: [
                'waktu_konsultasi'
            ],
            listJenisKelamin: [
                {
                    label: 'Perempuan',
                    value: 0,
                },
                {
                    label: 'Laki-Laki',
                    value: 1,
                }
            ],
            option_jenis_kunjungan: [
                { label: "Kunjungan Sehat", value: 1 },
                { label: "Kunjungan Sakit", value: 2 }
            ],
            option_perawatan: [
                { label: "Rawat Jalan", value: "10" },
                { label: "Promotif Preventif", value: "50" }
            ],
            option_kegiatan: [],
            selectedJenisKelamin: null,
            selectedKunjungan: null,
            selectedPerawatan: null,
            selectedKegiatan: null,
            detailAntrean: null,
            dataPeserta: null,
            visible_section_2: true,
            visible_section_1: true,
        };
    },
    computed: {
        ...mapGetters(['getKlinikId', 'getRolesName', 'klinikUser']),
        minDate() {
            return moment().subtract(3, 'months').toDate();
        },
        maxDate() {
            return moment().toDate()
        },
        selectedPeriodeRange() {
            const {
                periodeSelected
            } = this;
            return /(pilih)/gi.test(periodeSelected);
        },
        filterPeriode() {
            return (
                ['hari ini', 'minggu ini', 'bulan ini', 'pilih tanggal'] |> (x => x.map(item => ({
                    value: item,
                    text: startCase(item)
                })))
            );
        },
        fieldList() {
            const fields = [{
                    key: 'no',
                    thStyle: 'min-width: 50px',
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'waktu_konsultasi',
                    label: 'waktu konsultasi',
                    thStyle: 'min-width: 200px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'jenis_kunjungan',
                    label: 'jenis kunjungan',
                    thStyle: 'min-width: 230px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'perawatan',
                    label: 'perawatan',
                    thStyle: 'min-width: 230px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'kegiatan',
                    label: 'poli/kegiatan',
                    thStyle: 'min-width: 230px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                // {
                //     key: 'nama_poli',
                //     label: 'nama poli',
                //     thStyle: 'min-width: 150px',
                //     sortable: false,
                //     thClass: 'text-center align-middle',
                //     substr: 110,
                // },
                {
                    key: 'nama_dokter',
                    label: 'nama dokter',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'nama_pasien',
                    label: 'nama pasien',
                    thStyle: 'min-width: 200px',
                    sortable: true,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'bpjs_noka',
                    label: 'no. BPJS',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'tanggal_lahir',
                    thStyle: 'min-width: 170px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'usia',
                    label: 'usia',
                    thStyle: 'min-width: 150px',
                    sortable: true,
                    thClass: 'text-center align-middle',
                    substr: 100,
                },
                {
                    key: 'jenis_kelamin',
                    label: 'jenis kelamin',
                    thStyle: 'min-width: 170px',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'nama_provinsi',
                    label: 'provinsi',
                    thStyle: 'min-width: 170px',
                    sortable: true,
                    thClass: 'text-center align-middle',
                    substr: 120,
                },
                {
                    key: 'nama_kota',
                    label: 'kota/ kabupaten',
                    thStyle: 'min-width: 170px',
                    sortable: true,
                    thClass: 'text-center align-middle',
                    substr: 120,

                },
                {
                    key: 'alamat_rumah',
                    label: 'alamat',
                    thStyle: 'min-width: 170px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 120,
                },
                {
                    key: 'nomor_rekam_medis',
                    label: 'no. rekam medis',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'diagnosis_icd_x',
                    thStyle: 'min-width: 250px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'nama_tindakan',
                    label: 'tindakan',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'nama_obat_bhp',
                    label: 'nama obat',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,

                },
                {
                    key: 'jumlah_obat_bhp',
                    label: 'jumlah obat',
                    thStyle: 'min-width: 200px',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'actions',
                    stickyColumn: true,
                    isRowHeader: true,
                    sortable: false,
                    thStyle: 'min-width: 150px',
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle th-actions',
                }
            ];
            return fields;
        },
        formattedTanggalLahir() {
            if (!this.dataPeserta || !this.dataPeserta.tglLahir) return "-";
            const tgl = this.dataPeserta.tglLahir.replace(/-/g, "/");
            const umur = `${this.detailAntrean.pasien.age_year} tahun ${this.detailAntrean.pasien.age_month} bulan ${this.detailAntrean.pasien.age_day} hari`;
            return `${tgl} (${umur})`;
        }
    },
    watch: {
        sortBy() {
            this.fetchData();
        },
        sortDesc() {
            this.fetchData();
        },
        searchValue: {
            handler: 'fetchData',
            deep: true
        },
        periodeSelected(val) {
            if (val !== 'pilih tanggal') {
                this.fetchData();
            } else {
                this.dateRange = null;
            }
        },
        dateRange: {
            handler: function (val) {
                if (this.periodeSelected === 'pilih tanggal') {
                    this.fetchData();
                }
            },
            deep: true
        },
        selectedJenisKelamin: {
            handler: function (val) {
                this.fetchData();
            },
            deep: true
        },
        selectedKunjungan: {
            handler: function () {
                this.fetchData();
            },
            deep: true
        },
        selectedPerawatan: {
            handler: function () {
                this.fetchData();
            },
            deep: true
        },
        selectedKegiatan: {
            handler: function () {
                this.fetchData();
            },
            deep: true
        }
    },
    mounted() {
        this.fetchData();
        this.loadKegiatan();
    },
    methods: {
        thousandSeparator(num, withRp) {
            return ThousandSeparator(num, withRp)
        },
        disabledDate(val) {
            const monthsBefore = moment(val).diff(moment(), 'months', true);
            return !(
                moment(val).diff(moment(), 'months', true) |> (x => x < 1 && x >= -3.0 && moment(val).isSameOrBefore(moment()))
            );
        },
        searchValueChanged: debounce(function (val, key) {
            const {
                searchValue
            } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        periodeX({
            periode = null,
            rawValue = false
        } = {}) {
            const formatBackendDate = 'YYYY-MM-DD';
            const rawValueFormat = 'DD-MMM-YYYY';
            switch (periode && periode.toLowerCase()) {
                case 'pilih tanggal':
                    const {
                        dateRange
                    } = this;
                    if (dateRange) {
                        const { start: startDate, end: endDate } = dateRange;
                        const formatDate = 'DD-MM-YYYY';
                        if (rawValue) {
                            return `${moment(startDate, formatDate).format(rawValueFormat)} - ${moment(endDate, formatDate).format(rawValueFormat)}`;
                        } else {
                            return `&from=${moment(startDate, formatDate).format(
                                formatBackendDate
                            )}&to=${moment(endDate, formatDate).format(formatBackendDate)}`;
                        }
                    } else {
                        return null;
                    }

                case 'hari ini':
                    const today = moment().format(formatBackendDate);
                    return rawValue ?
                        moment().format(rawValueFormat) :
                        Array(2)
                            .fill(today)
                            .map(
                                (val, index) =>
                                    `&${(item => (item ? 'to' : 'from'))(index)}=${val}`
                            )
                            .join('');

                case 'minggu ini':
                    const startWeek = moment().startOf('isoWeek');
                    const endWeek = moment().endOf('isoWeek');
                    return rawValue ?
                        `${startWeek.format(rawValueFormat)}-${endWeek.format(
                            rawValueFormat
                        )}` :
                        `&from=${startWeek.format(formatBackendDate)}&to=${endWeek.format(
                            formatBackendDate
                        )}`;

                case 'bulan ini':
                    const startMonth = moment().startOf('month');
                    const endMonth = moment().endOf('month');
                    return rawValue ?
                        `${startMonth.format(rawValueFormat)}-${endMonth.format(
                            rawValueFormat
                        )}` :
                        `&from=${startMonth.format(
                            formatBackendDate
                        )}&to=${endMonth.format(formatBackendDate)}`;

                default:
                    break;
            }
        },
        handleValueChanged({ perPage, currentPage }) {
            if (this.perPage) this.perPage = perPage;
            if (this.perPage) this.currentPage = currentPage;
            this.fetchData();
        },
        onSearch(val) {
            if (!val) return;
            this.search(val, this);
        },
        determineParameter() {
            const {
                periodeX,
                periodeSelected: periode,
                sortBy,
                sortDesc,
                searchValue,
                selectedJenisKelamin,
                selectedKunjungan,
                selectedPerawatan,
                selectedKegiatan
            } = this;

            let tmp = '';
            tmp += `${periodeX({ periode })}`;
            searchValue.map(item => {
                let x = item.key;
                tmp += `&${x}=${item.value}`;
            });

            if (selectedJenisKelamin) {
                const { value } = selectedJenisKelamin;
                tmp = `&jenis_kelamin=${value}${tmp}`;

            }

            if (selectedKunjungan) {
                const { value } = selectedKunjungan;
                tmp = `&jenis_kunjungan=${value}${tmp}`;
            }

            if (selectedPerawatan) {
                const { value } = selectedPerawatan;
                tmp = `&perawatan=${value}${tmp}`;

            }

            if (selectedKegiatan) {
                // const { id } = selectedKegiatan;
                tmp = `&kegiatan=${selectedKegiatan}${tmp}`;
            }

            if (sortBy) {
                let column = sortBy
                if (column == 'usia') tmp += `&column=tanggal_lahir_sort&order=${sortDesc ? 'asc' : 'desc'}`;
                else if (column == 'tanggal_lahir') tmp += `&column=tanggal_lahir_sort&order=${sortDesc ? 'desc' : 'asc'}`;
                else tmp += `&column=${column}&order=${sortDesc ? 'desc' : 'asc'}`;
            }

            return tmp;
        },
        async fetchData() {
            try {
                const {
                    searchValue,
                    determineParameter
                } = this;
                const res = await this.$axios.get(
                    `pembayaran/pendapatan-klinik?klinik_id=${this.getKlinikId}&kategori=bpjs&limit=${this.perPage}&page=${this.currentPage
                    }${determineParameter()}`
                );
                const {
                    success,
                    data: {
                        pendapatan,
                        periode,
                        total_pasien,
                        total_pendapatan
                    }
                } = res.data;

                if (success) {
                    let {
                        data: listLaporanPendapatan,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = pendapatan;
                    const copyObj = Object.assign({}, listLaporanPendapatan[0]);
                    const tmp = Object.keys(copyObj).map(item => {
                        copyObj[item] = null;
                    });
                    const tmpList = [
                        ...listLaporanPendapatan.map((item, index) => ({
                            ...item,
                            waktu_konsultasi: (e =>
                                moment(e, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss'))(
                                    item.waktu_konsultasi
                                ),
                            no: (this.currentPage - 1) * this.perPage + index + 1
                        }))
                    ];

                    this.dataList = (tmpList &&
                        tmpList.length > 0 && [
                            Object.assign(copyObj, {
                                leaveBlank: true
                            }),
                            ...tmpList
                        ]) || [...tmpList, {
                            leaveBlank: true
                        }];
                    this.totalPasienValue = total_pasien;
                    this.periodeValue = periode;
                    this.rows = totalEntries;
                    this.totalEntries = totalEntries;
                    this.toPage = toPage || 0;
                    this.fromPage = fromPage || 0;
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
        async download() {
            try {
                const res = await this.$axios.get(`pembayaran/pendapatan-klinik/download?${this.determineParameter()}&klinik_id=${this.getKlinikId}&kategori=bpjs`);
                window.open(res.data.data.link, '_blank');
            } catch (err) {
                // console.log(err);
            }
        },
        detailPembayaran(id) {
            window.open(window.location.origin + `/klinik/pembayaran/struk/${id}`);
        },
        async loadKegiatan() {
            try {
                const res = await this.$axios.get(`kegiatan-poli/klinik/${this.getKlinikId}`);
                this.option_kegiatan = res.data;
                // console.log(this.option_kegiatan);
            } catch (error) {
                console.error("Gagal load kegiatan:", error);
            }
        },
        async showDetailAntrean(id){
            try {
                const { success, data, data_peserta_bpjs } = (
                await this.$axios.get(
                    `transaksi/${id}?klinik_id=${this.getKlinikId}`
                )
                ).data;
                if (success) {
                    this.detailAntrean = data;
                    this.dataPeserta = data_peserta_bpjs.message.response;
                    this.toggleDetailAntrean();
                }
            } catch (err) {
                console.error(err);
            }
        },
        toggleDetailAntrean() {
            this.$refs["my-modal"].toggle("#toggle-btn");
        },
        onHiddenModalDetailHandler() {
            this.detailAntrean = null;
            this.visible_section_1 = true;
            this.visible_section_2 = true;
        },
        formatDateTime(datetime) {
            if (!datetime) return "-";
            const [date, time] = datetime.split(" ");
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year} ${time}`;
        },
    }
};
</script>
  
<style lang="scss">
    $baseBgColor: #e6e6e6;
    $evenBgColor: #f9f9f9;

    .laporan-pendapatan-wrapper {
        $border-radius: 12px;
        border-top-left-radius: $border-radius;
        border-top-right-radius: $border-radius;
        background-color: $baseBgColor;
        color: #4c6e8a !important;

        section {
            table {
                thead {
                    tr {
                        th {
                            background-color: transparent !important;
                            color: #4c6e8a !important;
                            border: none !important;
                        }
                    }
                }

                tbody {
                    tr {
                        &:nth-child(even) {
                            background-color: #f9f9f9;
                        }
                    }
                }
            }
        }

        .el-range-separator {
            width: 35px;
        }
    }

    .custom-v-select {
        .vs__dropdown-toggle {
            max-height: 29.94px;
            background-color: #fff;
            overflow: hidden;
        }

        .vs__dropdown-menu {
            width: auto !important;
        }
    }

    @media screen and (min-width: 993px) {
        .text-right-lg {
            text-align: right;
        }
    }

    /* width */
    #report-revenue-table::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    #report-revenue-table::-webkit-scrollbar-track {
        box-shadow: inset 0 0 1px grey;
        border-radius: 10px;
    }

    /* Handle */
    #report-revenue-table::-webkit-scrollbar-thumb {
        background: #cdcdcd;
        border-radius: 10px;
    }

    /* Handle on hover */
    #report-revenue-table::-webkit-scrollbar-thumb:hover {
        background: #cdcdcd;
    }

    @media only screen and (max-width: 1550px) and (min-width: 1280px) {
        body {
            overflow-x: hidden;
        }

        ::-webkit-scrollbar {
            width: initial;
        }

        #report-revenue-table {
            max-width: 100% !important;
        }
    }

    @media screen and (min-width: 1300px) {
        body {
            overflow-x: visible;
        }

        body::-webkit-scrollbar-track {
            box-shadow: inset 0 0 1px grey;
            border-radius: 10px;
        }

        body::-webkit-scrollbar-thumb {
            background: #cdcdcd;
            border-radius: 10px;
        }

        #report-revenue-table {
            max-width: 100% !important;
        }

        ul {
            margin: 0;
        }

        ul.dashed {
            list-style-type: none;
        }

        ul.dashed>li {
            text-indent: -5px;
        }

        ul.dashed>li:before {
            content: "-";
            text-indent: -5px;
        }
        ul.hide-li {
            list-style: none;
        }
    }
    .custom-tooltip .tooltip .tooltip-inner {
        max-width: 500px !important;
        width: 300px !important;
    }
    .modal-backdrop {
        opacity: 0.5 !important;
    }
    .modal_detail_antrean .modal-header {
        background-color: #4896e8;
        color: white;
    }

    .modal_detail_antrean > header > button.close {
        float: right;
        font-size: 1.425rem;
        font-weight: 700;
        line-height: 1;
        text-shadow: 0 1px 0 #fff;
        opacity: 0.5;
        color: white;
    }

    .modal_detail_antrean .modal-body {
        background-color: #fff;
    }

    .modal_detail_antrean .modal-footer {
        background-color: #fff;
    }

    .rotate-0 {
        transform: rotate(0deg);
        transition: transform 0.3s ease;
    }

    .rotate-90 {
        transform: rotate(-90deg);
        transition: transform 0.3s ease;
    }
</style>

<style>
    .th-actions {
        position: sticky;
        right: 0; 
        z-index: 5;
    }
    #report-purchase-table tbody tr th {
        position: sticky;
        right: 0; 
        z-index: 5;
        background-color: white;
    }
    .table.b-table > thead > tr > th.b-table-sticky-header {
        position: sticky !important;
    }
    .table.b-table > tbody > tr > td.b-table-sticky-column {
        position: sticky !important;
    }
    .sorticon [aria-sort] {
        background-position: right calc(0.75rem / 2) top 35px !important;
        padding-right: calc( 0.75rem + 0.65em ) !important;
    }
</style>
  